import axios from 'axios';
import { config } from '../../config';

export default {
    namespaced: true, // Activa el namespacing para este módulo

    actions: {
        async mercadoPago_createPayment(_, formData) {
            return new Promise((resolve, reject) => {
                axios.post(config.apiUrl + '/mercado-pago/create-payment', formData)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error.response);
                    });
            });
        },
    }
}